/**
 * Tailwind doesn't allow us to use dynamic class names, so we have to map them ourselves
 * Add colors to the map as needed
 * Add properties to the ColorStyle type as needed
 */
export const colorStyleMap = new Map<string, ColorStyle>([
  [
    'logo-lime',
    {
      background: 'bg-logo-lime',
      backgroundOpacity12: 'bg-logo-lime/[.12]',
      border: 'border-logo-lime',
      button: 'btn-lime',
      fill: 'fill-logo-lime',
      stroke: 'stroke-logo-lime',
      text: 'text-logo-lime',
    },
  ],
  [
    'primary-blue',
    {
      background: 'bg-primary-blue',
      backgroundOpacity12: 'bg-primary-blue/[.12]',
      border: 'border-primary-blue',
      button: 'btn-blue',
      fill: 'fill-primary-blue',
      stroke: 'stroke-primary-blue',
      text: 'text-primary-blue',
    },
  ],
  [
    'primary-green',
    {
      background: 'bg-primary-green',
      backgroundOpacity12: 'bg-primary-green/[.12]',
      border: 'border-primary-green',
      button: 'btn-green',
      fill: 'fill-primary-green',
      stroke: 'stroke-primary-green',
      text: 'text-primary-green',
    },
  ],
  [
    'primary-teal',
    {
      background: 'bg-primary-teal',
      backgroundOpacity12: 'bg-primary-teal/[.12]',
      border: 'border-primary-teal',
      button: 'btn-teal',
      fill: 'fill-primary-teal',
      stroke: 'stroke-primary-teal',
      text: 'text-primary-teal',
    },
  ],
  [
    'accent-yellow',
    {
      background: 'bg-accent-yellow',
      backgroundOpacity12: 'bg-accent-yellow/[.12]',
      border: 'border-accent-yellow',
      button: 'btn-yellow',
      fill: 'fill-accent-yellow',
      stroke: 'stroke-accent-yellow',
      text: 'text-accent-yellow',
    },
  ],
  [
    'accent-red',
    {
      background: 'bg-accent-red',
      backgroundOpacity12: 'bg-accent-red/[.12]',
      border: 'border-accent-red',
      button: 'btn-red',
      fill: 'fill-accent-red',
      stroke: 'stroke-accent-red',
      text: 'text-accent-red',
    },
  ],
  [
    'dark-navy-black',
    {
      background: 'bg-dark-navy-black',
      backgroundOpacity12: 'bg-dark-navy-black/[.12]',
      border: 'border-dark-navy-black',
      button: 'btn-navy-black',
      fill: 'fill-dark-navy-black',
      stroke: 'stroke-dark-navy-black',
      text: 'text-dark-navy-black',
    },
  ],
  [
    'dark-ocean',
    {
      background: 'bg-dark-ocean',
      backgroundOpacity12: 'bg-dark-ocean/[.12]',
      border: 'border-dark-ocean',
      button: 'btn-ocean',
      fill: 'fill-dark-ocean',
      stroke: 'stroke-dark-ocean',
      text: 'text-dark-ocean',
    },
  ],
  [
    'fresh-scent',
    {
      background: 'bg-fresh-scent',
      backgroundOpacity12: 'bg-fresh-scent/[.12]',
      border: 'border-fresh-scent',
      button: 'btn-fresh-scent',
      fill: 'fill-fresh-scent',
      stroke: 'stroke-fresh-scent',
      text: 'text-fresh-scent',
    },
  ],
  [
    'light-breeze',
    {
      background: 'bg-light-breeze',
      backgroundOpacity12: 'bg-light-breeze/[.12]',
      border: 'border-light-breeze',
      button: 'btn-ocean',
      fill: 'fill-light-breeze',
      stroke: 'stroke-light-breeze',
      text: 'text-light-breeze',
    },
  ],
  [
    'sunshine',
    {
      background: 'bg-sunshine',
      backgroundOpacity12: 'bg-sunshine/[.12]',
      border: 'border-sunshine',
      button: 'btn-ocean',
      fill: 'fill-sunshine',
      stroke: 'stroke-sunshine',
      text: 'text-sunshine',
    },
  ],
  [
    'breeze-blue',
    {
      background: 'bg-breeze-blue',
      backgroundOpacity12: 'bg-breeze-blue/[.12]',
      border: 'border-breeze-blue',
      button: 'btn-breeze-blue',
      fill: 'fill-breeze-blue',
      stroke: 'stroke-breeze-blue',
      text: 'text-breeze-blue',
    },
  ],
  [
    'deep-ocean-blue',
    {
      background: 'bg-deep-ocean-blue',
      backgroundOpacity12: 'bg-deep-ocean-blue/[.12]',
      border: 'border-deep-ocean-blue',
      button: 'btn-ocean',
      fill: 'fill-deep-ocean-blue',
      stroke: 'stroke-deep-ocean-blue',
      text: 'text-deep-ocean-blue',
    },
  ],
]);

/**
 * Get the color style for a given color name
 * or return the default color style if the color name is not found
 */
export function getColorStyle(
  colorName: string,
  defaultColorName = 'primary-blue'
): ColorStyle {
  return colorStyleMap.get(colorName) ?? colorStyleMap.get(defaultColorName)!;
}

export type ColorStyle = {
  background: string;
  backgroundOpacity12: string;
  border: string;
  button: string;
  fill: string;
  stroke: string;
  text: string;
};
